import { create } from 'zustand';
import { TMap } from '@client/new/helpers/types';
import { Breakpoints, breakpoints } from './tokens';

type BreakpointsState = TMap<Breakpoints, boolean> & {
  breakpoint: Breakpoints;
};

const getBreakpointByWidth = (width: number): Breakpoints =>
  width <= breakpoints.mobile.max
    ? 'mobile'
    : width <= breakpoints.tablet.max
    ? 'tablet'
    : 'desktop';

const getBreakpointsState = (breakpoint: Breakpoints): BreakpointsState => ({
  breakpoint,
  mobile: breakpoint === 'mobile',
  tablet: breakpoint === 'tablet',
  desktop: breakpoint === 'desktop',
  largeDesktop: breakpoint === 'largeDesktop',
});

export const useBreakpoints = create<BreakpointsState>(() =>
  getBreakpointsState(getBreakpointByWidth(window.innerWidth)),
);

window.addEventListener('resize', () =>
  useBreakpoints.setState(
    getBreakpointsState(getBreakpointByWidth(window.innerWidth)),
  ),
);
